import React from 'react'
import PropTypes from 'prop-types'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import CheckboxSquareField from './CheckboxSquareField'

const handleChange = (value, name, current = [], setValue) => {
  const currentItemIntex = current.findIndex((item) => item === value.id)
  const currentItem = current[currentItemIntex]
  const newValue = [...current]

  if (value.status) {
    if (currentItem) return

    newValue.push(value.id)
  } else {
    if (!currentItem) return

    newValue.splice(currentItemIntex, 1)
  }

  setValue(name, newValue)
}

const CheckboxMultField = (props) => {
  const {
    options,
    initialValues,
    field: { name = '', id: fieldId, value } = {},
    form: { setFieldValue } = {}
  } = props

  const optionsComponent = options.map((option, index) => {
    const initialCheck = value.find((filter) => filter === option.id)

    return (
      <Flex key={option.id} alignItems="center" justifyContent="space-between">
        <Text
          value={option.name}
          font="custom"
          size="xs"
          color="gray"
          variation="dark"
          captalize
        />

        <CheckboxSquareField
          fieldId={fieldId}
          initialCheck={initialCheck}
          reinitializeControl={initialValues}
          name={`${name}.${index}`}
          transform={(_, checked) => ({
            id: option.id,
            status: checked
          })}
          onChange={(newValue) => {
            return handleChange(newValue, name, value, setFieldValue)
          }}
        />
      </Flex>
    )
  })

  return <div name={name}>{optionsComponent}</div>
}

CheckboxMultField.defaultProps = {
  options: [],
  initialValues: [],
  field: undefined,
  form: undefined
}

CheckboxMultField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  initialValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
  ),
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    )
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({})
  })
}

export default CheckboxMultField
